import gql from 'graphql-tag'
import React, { useContext, useState } from 'react';
import { Button, Form } from 'semantic-ui-react';
import { useMutation } from '@apollo/client'
// import { useMutation } from '@apollo/react-hooks';
import { useForm } from '../util/hooks'
import { AuthContext } from '../context/auth'
export default function Login(props) {
    const context = useContext(AuthContext)
    const [errors, setErrors] = useState({})

    const { onChange, onSubmit, values } = useForm(loginUserCallback, {
        username: "",
        password: ""
    })

    const [loginUser, { loading }] = useMutation(LOGIN_USER, {
        update(_, { data: { login: userData } }) {
            console.log(userData)
            context.login(userData)
            props.history.push("/")
        },
        onError(err) {
            setErrors(err.graphQLErrors[0].extensions.exception.errors);

        },
        variables: values
    })

    function loginUserCallback() {
        // event.preventDefault();
        loginUser();
    }


    return (
        <div className="form-container">
            <Form onSubmit={onSubmit} noValidate className={loading ? "loading" : ""}>
                <h1>Login</h1>
                <Form.Input
                    lable="Username"
                    placeholder="Username.."
                    name="username"
                    type="text"
                    value={values.username}
                    onChange={onChange}
                    error={errors.username ? true : false}
                />
                <Form.Input
                    lable="Password"
                    placeholder="Password.."
                    name="password"
                    type="password"
                    value={values.password}
                    onChange={onChange}
                    error={errors.password ? true : false}
                />
                <Button type="submit" primary>Login</Button>
            </Form>
            {
                Object.keys(errors).length > 0 && (
                    <div className="ui error message">
                        <ul className="list">
                            {
                                Object.values(errors).map((value) => (
                                    <li key={value}>{value}</li>
                                ))
                            }
                        </ul>

                    </div>
                )}

        </div>
    )
}

const LOGIN_USER = gql`

mutation login(
    $username:String!
    $password:String!
){
    login(
            username:$username password:$password        
    ){
        id email username createdAt token
    }
}


`